module.exports = __webpack_public_path__ + "img/inline-desktop-english.4a83d61a.png";